module.exports = __webpack_public_path__ + "img/account.1abe5ef3.webp";